import { Button, ColumnDefinition, ComboBox, Modal, Table, TextInput } from '@abb/common-ux';
import { SERVER_ID_FIELD_MAX_LENGTH } from '@service/constants';
import * as React from 'react';
import { Option } from 'react-select';
import { IServer, Server } from '../../../models';
/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
export default class ServerTable extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      isModalOpen: false,
      serverToDelete: null,
      preEditServer: new Server(),
      serverId: {
        serverIdFirstSection: '',
        serverIdSecondSection: '',
        serverIdThirdSection: '',
        serverIdFourthSection: ''
      }
    };
  }
  render() {
    const ServerTableColumn = ColumnDefinition as new () => ColumnDefinition<IServer>;

    const deleteButton = (
      <span>
        <Button buttonType='normal' buttonSize='default' onClick={() => {
          this.setState({
            isModalOpen: false,
            serverToDelete: null
          });
        }} >
          <span aria-hidden='true'>Cancel</span>
        </Button>
        <Button buttonType='primary' buttonSize='default' onClick={() => {
          this.props.DeleteServer(this.state.serverToDelete);
          this.setState({
            isModalOpen: false,
            serverToDelete: null
          });
        }} >
          <span aria-hidden='true'>Confirm</span>
        </Button>
      </span>);

    const hardwareTable = (<Table data={this.props.server} emptyMessage={'This site has no hardware.'}>
        <ServerTableColumn cell={(row) => this.renderDescription(row)} header='Description' />
        <ServerTableColumn cell={(row) => this.renderServerIdTextInput(row)} header='Hardware ID' />
        <ServerTableColumn cell={(row) => this.renderComboBoxCol(row, this.props.operationalUsages)} header='Operational Use' />
        <ServerTableColumn cell={(row) => this.renderManageButtons(row)} header='Manage' />
      </Table>);

    return (
      <div>
        {hardwareTable}
        <Modal isOpen={this.state.isModalOpen}
          header='Confirmation'
          footer={deleteButton}
          onClose={() => { this.closeModal(); }}
          modalClassName='styleGuideModal'>
          Deleting hardware removes all corresponding instances. Please confirm.
        </Modal>
      </div>
    );
  }

  componentWillReceiveProps(props: any) {
    if (props.serverIsAddingNew) {
      this.setState({
        serverId: {
          serverIdFirstSection: '',
          serverIdSecondSection: '',
          serverIdThirdSection: '',
          serverIdFourthSection: ''
        }
      });
    }
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
      serverToDelete: null
    });
  }

  renderDescription(server: IServer) {
    if (server.isBeingEdited) {
      return <TextInput name='NewServerDescription'
        labelText=''
        inputSize='small'
        value={server.description.value}
        validationState={server.description.valid ? 'valid' : 'invalid'}
        errorMessage='Description must be unique and cannot exceed 100 characters; may include "-", "_", "(", ")". "'
        onChange={(event: React.ChangeEvent<any>) => {
          this.props.ServerDescriptionEdit(event.target.value);
        }} />;
    }
    return server.description.value;
  }

  renderManageButtons(server: IServer) {

    if (server.isBeingEdited) {
      return <div>
        <Button buttonType='normal' buttonSize='minimal' icon='save' onClick={() => this.handleSaveEdit(server)
        } disabled={!server.description.valid || !server.serverId.valid} />
        <Button buttonType='normal' buttonSize='minimal' icon='close' onClick={() => this.handleCancelEdit(server)} />
      </div >;
    }
    return <div>
      <Button buttonType='normal' buttonSize='minimal' icon='edit' onClick={() => this.handleEditExistingRow(server)} />
      <Button buttonType='normal' buttonSize='minimal' icon='trash' onClick={() => {
        this.setState({
          isModalOpen: true,
          serverToDelete: server
        });
      }} />
    </div>;
  }

  handleEditExistingRow(server: IServer) {
    this.setState({
      preEditServer: server
    });
    this.props.EditExistingRow(server);
    const serverIdSections = server.serverId.value.split('-');
    this.setState({
      serverId: {
        serverIdFirstSection: serverIdSections[0],
        serverIdSecondSection: serverIdSections[1],
        serverIdThirdSection: serverIdSections[2],
        serverIdFourthSection: serverIdSections[3]
      }
    });
  }

  handleSaveEdit(server: IServer) {
    this.props.UpdateServer(server);
    this.setState({
      preEditServer: new Server()
    });
  }

  handleCancelEdit(server: IServer) {
    this.props.ServerCancelEdit(this.state.preEditServer);
    this.setState({
      preEditServer: new Server()
    });
  }

  renderServerIdTextInput(server: IServer) {
    if (server.isBeingEdited) {
      return <div>
        <div className='serverIdInput'>
          <TextInput
            name='NewServerId'
            labelText=''
            inputSize='small'
            validationState={server.serverId.valid ? 'valid' : 'invalid'}
            errorMessage='Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort'
            value={this.state.serverId.serverIdFirstSection}
            inputProps={{ maxLength: SERVER_ID_FIELD_MAX_LENGTH, id: '1' }}
            onChange={(event: React.ChangeEvent<any>) => {
              this.handleServerIdFieldChange(event.target.value, this.state.serverId.serverIdSecondSection, this.state.serverId.serverIdThirdSection, this.state.serverId.serverIdFourthSection);
              this.TabIfMaxLength(event.target.value, '1');
            }}
          />
        </div>
        <div className='serverIdInputSeperator'>-</div>
        <div className='serverIdInput'>
          <TextInput name='NewServerId2'
            labelText=''
            inputSize='small'
            inputProps={{ maxLength: SERVER_ID_FIELD_MAX_LENGTH, id: '2' }}
            validationState={server.serverId.valid ? 'valid' : 'invalid'}
            errorMessage='Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort'
            value={this.state.serverId.serverIdSecondSection}
            onChange={(event: React.ChangeEvent<any>) => {
              this.handleServerIdFieldChange(this.state.serverId.serverIdFirstSection, event.target.value, this.state.serverId.serverIdThirdSection, this.state.serverId.serverIdFourthSection);
              this.TabIfMaxLength(event.target.value, '2');
            }} />
        </div>
        <div className='serverIdInputSeperator'>-</div>
        <div className='serverIdInput'>
          <TextInput name='NewServerId3'
            labelText=''
            inputSize='small'
            inputProps={{ maxLength: SERVER_ID_FIELD_MAX_LENGTH, id: '3' }}
            validationState={server.serverId.valid ? 'valid' : 'invalid'}
            errorMessage='Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort'
            value={this.state.serverId.serverIdThirdSection}
            onChange={(event: React.ChangeEvent<any>) => {
              this.handleServerIdFieldChange(this.state.serverId.serverIdFirstSection, this.state.serverId.serverIdSecondSection, event.target.value, this.state.serverId.serverIdFourthSection);
              this.TabIfMaxLength(event.target.value, '3');
            }} />
        </div>
        <div className='serverIdInputSeperator'>-</div>
        <div className='serverIdInput'>
          <TextInput name='NewServerId4'
            labelText=''
            inputSize='small'
            inputProps={{ maxLength: SERVER_ID_FIELD_MAX_LENGTH, id: '4' }}
            validationState={server.serverId.valid ? 'valid' : 'invalid'}
            errorMessage='Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort'
            value={this.state.serverId.serverIdFourthSection}
            onChange={(event: React.ChangeEvent<any>) => {
              this.handleServerIdFieldChange(this.state.serverId.serverIdFirstSection, this.state.serverId.serverIdSecondSection, this.state.serverId.serverIdThirdSection, event.target.value);
            }} />
        </div>
      </div>;
    }
    return server.serverId.value;
  }

  handleServerIdFieldChange(serverIdFirstSection: string, serverIdSecondSection: string, serverIdThirdSection: string, serverIdFourthSection: string) {
    this.setState({
      serverId: Object.assign({}, this.state.serverId, {
        serverIdFirstSection,
        serverIdSecondSection,
        serverIdThirdSection,
        serverIdFourthSection
      })
    });
    this.props.ServerServerIdEdit(serverIdFirstSection + '-' + serverIdSecondSection + '-' + serverIdThirdSection + '-' + serverIdFourthSection);
  }

  TabIfMaxLength(value: string, id: string) {
    if (value.length >= SERVER_ID_FIELD_MAX_LENGTH) {
      document.getElementById((Number(id) + 1).toString())!.focus();
    }
  }

  renderComboBoxCol(server: IServer, operationalUsages: any) {
    if (server.isBeingEdited) {
      // TODO: get operational usages values from API call to Server/New?
      const value = {
        value: server.operationalUseType.id,
        label: server.operationalUseType.usageName
      };
      return <ComboBox onChange={(newOption: Option) => {
        this.props.ServerOperationUseChange(newOption);
      }} value={value} size='small' options={operationalUsages} />;
    }
    return server.operationalUseType.usageName;
  }
}

export interface IHardwareTableProps {
  preEditServer: IServer;
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/Hardware/HardwareTable.tsx